import { render, staticRenderFns } from "./OrbitCardCarousel.vue?vue&type=template&id=c22ce764&scoped=true"
import script from "./OrbitCardCarousel.vue?vue&type=script&lang=ts"
export * from "./OrbitCardCarousel.vue?vue&type=script&lang=ts"
import style0 from "./OrbitCardCarousel.vue?vue&type=style&index=0&id=c22ce764&prod&lang=scss&scoped=true"
import style1 from "./OrbitCardCarousel.vue?vue&type=style&index=1&id=c22ce764&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22ce764",
  null
  
)

export default component.exports